<script setup lang="ts">
import { computed } from 'vue';

import AppDots from '../appDots/AppDots.vue';

interface AppGalleryDotsProps {
  currentSlide: number;
  numberOfSlides: number;
}

const props = defineProps<AppGalleryDotsProps>();

interface AppGalleryDotsEmits {
  (event: 'dot-clicked', slide: number): void;
}

const emit = defineEmits<AppGalleryDotsEmits>();

const MAX_DOTS = 3;

const currentDotIndex = computed<number>(
  () => (props.currentSlide % MAX_DOTS) + 1
);

// TODO: Add unit tests for below functions
function isLastStage(): boolean {
  const currentStage = Math.floor(props.currentSlide / MAX_DOTS);
  const lastStage = Math.floor(props.numberOfSlides / MAX_DOTS);
  return currentStage === lastStage;
}

function getMissingDots(): number {
  const lastDot = props.numberOfSlides % MAX_DOTS;
  return MAX_DOTS - lastDot;
}

function getSlideFromRelativeDot(dot: number): number {
  const currentStage = Math.floor(props.currentSlide / MAX_DOTS);
  const firstDotInCurrentStage = currentStage * MAX_DOTS;
  return firstDotInCurrentStage - 1 + dot;
}

const disabledDots = computed<number | undefined>(() => {
  if (!isLastStage()) {
    return;
  } else {
    return getMissingDots();
  }
});
</script>

<template>
  <AppDots
    class="app-gallery-dots"
    :number-of-dots="MAX_DOTS"
    :active-dot-index="currentDotIndex"
    :disabled-dots="disabledDots"
    @dot-clicked="emit('dot-clicked', getSlideFromRelativeDot($event))"
  />
</template>
